/* eslint-disable */
// 校验手机号码
function mobileTest(mobile) {
  const reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
  return reg_tel.test(mobile)
}

// 获取url带过来的参数
function getUrlParam() {
  let url = window.location.href //获取url中"?"符后的字串
  const index = url.lastIndexOf("\?")
  const urlSplice = url.substring(index + 1, url.length)
  const strs = urlSplice.split("&")
  let obj = {}
  strs.map(el => {
    const indexEl = el.lastIndexOf("\=")
    const value = el.substring(indexEl + 1, el.length)
    const key = el.substring(0, indexEl)
    obj[key] = decodeURIComponent(value)
  })
  console.log(obj, 'obj');
  return obj
}

export default {
  mobileTest,
  getUrlParam
}


// WEBPACK FOOTER //
// ./src/Utils/utils.js